import React from 'react'
import ImageScroller from './ImageScroller/Imagescroller'
import TeamPage from './team/TeamPage'

export default function ContentMain() {
  return (
    <div >
          
          <div className="row gy-4">
        
                  <div className="" data-aos="fade-up" data-aos-delay="100">
                       
              <section id="testimonials" className="testimonials section">
        
           
            
        
              <div className="container" data-aos="fade-up" data-aos-delay="100">
        
               
                      <div className="testimonial-item">
                        <img src="assets/img/image.png" className="testimonial-img" alt="" style={{width:"150px"}} />
                        <h3>Rev. Dr. Joseph Antony Samy. G. SJ</h3>
                        <h4>The Director</h4>
                        <div className="stars">
                          <i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i>
                        </div>
                        <p style={{textAlign: 'justify', fontSize:"16px"}}>
                          <i className="bi bi-quote quote-icon-left"></i>
                          <span>Dear researcher, <br /> <br />
                                The Jesuit Madurai Province Archives is housed in the Sacred Heart College, Shenbaganur, Kodaikanal. It is a Historical Archives having Manuscripts, Diaries, Palm leaves, Photos, documents and Maps of the Old and New Madura mission of the Society of Jesus from 1542 onwards. Primarily it deals with the growth and development of the Jesuit Mission in the old Madras State. After 16th century, writing the history of Tamil Nadu will be incomplete without consulting the Jesuit Madurai Province Archives was the opinion of Prof. Sathiyanatha Iyer, a former Professor of the Madras University.
                                    Besides religious history, the archives could provide as an aside materials on the socio, economic, political, cultural and environmental history of Tamil Nadu to the researchers. It serves as a store house of general knowledge in Tamil, French, English, Latin and other languages. Missionaries like Constantine Joseph Beschi, Robert de Nobili and others have mastered the local language Tamil and had composed dictionaries, grammars, poems and introduced important and relevant changes to the script and form of Tamil language. Though it is a private archives, it keeps the door open to every researcher who is in search of authentic and objective knowledge about the past.</span>
                          <i className="bi bi-quote quote-icon-right"></i>
                        </p>
                      </div>
                    </div>
        
            </section>
            </div>

            <TeamPage />
            {/*<div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                       
              <section id="testimonials" className="testimonials section">
        
           
            
        
              <div className="container" data-aos="fade-up" data-aos-delay="100">
        
               
                      <div className="testimonial-item">
                        
                        <h3>History and Present Condition of Madurai Jesuit Province Archives</h3>
                        
                        <p style={{textAlign: 'justify'}}>
                          <i className="bi bi-quote quote-icon-left"></i>
                         It was only after the restoration of the Society of Jesus the archives began to take shape. In 1934 correspondences and diaries were stored at Trichy. The earliest and most substantial materials of the archives are related to the Jesuit Bishops Alexis Canoz, Jean Marie Barthe, Augustin Faisandier and other Jesuit bishops like Jean Peter Leonard and Tiburtius Roche. Till 1936 the documents preserved in the Cathedral residence of Jesuits at Tiruchirappalli were brought to Sacred Heart College(SHC), Shembaganur. This was because the Society of Jesus was handing over the Diocese of Trichinopoly to the local clergy. Hence the province had the responsibility of preserving the documents pertaining to the Jesuits separately. This they did in Shembaganur.

SHC started in 1895 and it housed the Jesuit scholastics, doing their spiritual formation (Novitiate), study of humanities (Juniorate), and Philosophy for the Madurai Mission. From 1937 onwards, one of the philosophy faculty, Fr. Gathier was in charge of the Archives. The first official archivist, Fr. Augustine Sauliere, the typist, Mr. Anthony Doss, and Fr. John Pujo, did a tremendous job in the Archives. From 1997 till 2005 many Jesuits took turns in serving at the Archives. From 2006 onwards the systematic work of scanning and computerizing the archival materials started by Fr. Joseph Antonysamy SJ. The particular portion of the building which houses the archives was constructed in 1924. The total carpet area of the archives is about 8300 sq feet.
                          <i className="bi bi-quote quote-icon-right"></i>
                        </p>
                      </div>
                    </div>
            </section>
            </div>

               <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                <ImageScroller />
               </div>*/}
            </div>
    </div>
  )
}
